import { Pipe, PipeTransform } from '@angular/core';

import { DateHelper, DateInput } from '@helpers/date.helper';

@Pipe({
  name: 'atBy',
  standalone: true
})
export class AtByPipe implements PipeTransform {
  transform(
    stringBegin: string,
    at: DateInput,
    by: string,
    format = 'DD/MM/YYYY à HH:mm',
    forceUtcConversion: boolean = false
  ): string {
    if (!at) {
      return '';
    }

    const formattedDate = DateHelper.format(forceUtcConversion ? DateHelper.fromUtc(at) : at, format);

    return `${stringBegin ? `${stringBegin} ` : ''}${formattedDate}${by ? ` par ${by}` : ''}`;
  }
}
